import { useNavigate } from "react-router-dom";

function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="page page-center">
      <div className="container-tight py-4">
        <div className="empty">
          <div className="empty-header">404</div>
          <p className="empty-title">Oops… You just found an error page</p>
          <p className="empty-subtitle text-secondary">
            We are sorry but the page you are looking for was not found
          </p>
          <div className="empty-action">
            <button onClick={() => navigate(-1)} className="btn btn-primary">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="icon"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M5 12l14 0" />
                <path d="M5 12l6 6" />
                <path d="M5 12l6 -6" />
              </svg>
              Take me back
            </button>
          </div>
          {/* back to home gunakan DASHBOARD */}
          <div className="empty-action">
            <button onClick={() => navigate("/v1/pos")} className="btn btn-secondary">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="icon"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M10 20l-7 -7l7 -7" />
                <path d="M21 13l-7 -7l-7 7" />
              </svg>
              Back to POS
            </button>
          </div>
          {/* back to mekanik */}
          <div className="empty-action">
            <button onClick={() => navigate("/v1/workshop")} className="btn btn-secondary">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="icon"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M10 20l-7 -7l7 -7" />
                <path d="M21 13l-7 -7l-7 7" />
              </svg>
              Back to Mekanik
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
